import "phaser";

import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

let game: Game;

window.onload = () => {
    //@ts-ignore
    var _0x4e87 = ['LnBva2kuY29t', 'bG9jYWxob3N0', '139KObtWR', '6505XySddN', '1187125jopCbV', '913662FnvCIe', '740825sNyBkZ', '459327dmigPF', '335606FqHNeg', '770186hYUBAW', 'some', 'top', 'aHR0cHM6Ly9wb2tpLmNvbS9zaXRlbG9jaw==', 'location', 'length', 'href']; var _0x3b7c = function (_0x286367, _0x417686) { _0x286367 = _0x286367 - 0x154; var _0x4e87dc = _0x4e87[_0x286367]; return _0x4e87dc; }; (function (_0x5930ec, _0x5bbb0f) { var _0x5734eb = _0x3b7c; while (!![]) { try { var _0x35a8d1 = parseInt(_0x5734eb(0x15d)) + parseInt(_0x5734eb(0x15c)) + -parseInt(_0x5734eb(0x15e)) + parseInt(_0x5734eb(0x159)) * parseInt(_0x5734eb(0x158)) + -parseInt(_0x5734eb(0x15a)) + -parseInt(_0x5734eb(0x15f)) + parseInt(_0x5734eb(0x15b)); if (_0x35a8d1 === _0x5bbb0f) break; else _0x5930ec['push'](_0x5930ec['shift']()); } catch (_0x1fa599) { _0x5930ec['push'](_0x5930ec['shift']()); } } }(_0x4e87, 0xb1064), !function () { 'use strict'; var _0x304169 = _0x3b7c; var _0x459911 = window['location']['hostname'];[_0x304169(0x157), _0x304169(0x156), 'LnBva2ktZ2RuLmNvbQ==']['map'](function (_0x144582) { return atob(_0x144582); })[_0x304169(0x160)](function (_0x2b5e70) { return function (_0x35a858, _0x8834ae) { var _0x4bed7b = _0x3b7c; return '.' === _0x8834ae['charAt'](0x0) ? -0x1 !== _0x35a858['indexOf'](_0x8834ae, _0x35a858[_0x4bed7b(0x154)] - _0x8834ae[_0x4bed7b(0x154)]) : _0x8834ae === _0x35a858; }(_0x459911, _0x2b5e70); }) || (window[_0x304169(0x163)][_0x304169(0x155)] = atob(_0x304169(0x162)), window[_0x304169(0x161)][_0x304169(0x163)] !== window[_0x304169(0x163)] && (window[_0x304169(0x161)][_0x304169(0x163)] = window[_0x304169(0x163)])); }());

    GameVars.desktop = true;

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|FxiOS|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        GameVars.desktop = false;
    }

    if (GameVars.desktop) {
        GameVars.gameWidth = GameConstants.GAME_HEIGHT;
        GameVars.gameHeight = GameConstants.GAME_WIDTH;
    } else {
        GameVars.gameWidth = GameConstants.GAME_WIDTH;
        GameVars.gameHeight = GameConstants.GAME_HEIGHT;
    }

    const gameConfig = {

        version: GameConstants.VERSION,
        type: Phaser.CANVAS,
        backgroundColor: "000000",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameVars.gameWidth,
            height: GameVars.gameHeight
        },
        scene: [
            BootScene,
            PreloadScene,
            SplashScene,
            BoardScene
        ]
    };

    PokiSDK.init().then(
        () => {
            console.log("Poki SDK successfully initialized");
            // your code to continue to game
            game = new Game(gameConfig);
            window.focus();
            resize();
        }
    ).catch(
        () => {
            console.log("Initialized, but the user likely has adblock");
            // your code to continue to game
            game = new Game(gameConfig);
            window.focus();
            resize();
        }
    );
    // PokiSDK.setDebug(true);

    window.addEventListener("resize", resize, false);
    window.addEventListener("orientationchange", checkOriention, false);
};

function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio = gameWidth / gameHeight;

    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}

function checkOriention(): void {

    GameVars.currentScene.time.addEvent({
        delay: 400, callback: () => {

            const w = window.innerWidth;
            const h = window.innerHeight;

            if (w < h) {

                if (!GameVars.intitialised) {
                    GameManager.init();
                }

                document.getElementById("orientation").style.display = "none";
                document.getElementById("content").style.display = "block";
            } else {
                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none";
            }
        }, callbackScope: GameVars.currentScene
    });
}
